import { render, staticRenderFns } from "./OperaStaffWindow.vue?vue&type=template&id=5c516ed0&"
import script from "./OperaStaffWindow.vue?vue&type=script&lang=js&"
export * from "./OperaStaffWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports